const ENCODING_CHARACTERS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz.~_-';
/**
 * Parses datastring to temperature data.
 * @param dataString The datastring from the downsampled url.
 * @param rangeStart The temperature value the encoded range starts with. Default is -12°C.
 * @param resolution The unit resolution the encoded range is in. Default is 1°C.
 * @returns An array with downsampled temperature values.
 */
export const parseTemperatureDatapoints = (dataString, rangeStart = -12, resolution = 1) => {
    if (!dataString)
        return [];
    const charToValue = {};
    // Populate the mapping from character to value, shifting values to start from given rangeStart
    ENCODING_CHARACTERS.split('').forEach((char, index) => (charToValue[char] = index * resolution + rangeStart));
    return dataString.split('').map((char) => {
        if (char in charToValue) {
            return charToValue[char];
        }
        else {
            throw new Error(`Invalid character: ${char}`);
        }
    });
};
/**
 * Parses datastring to humidity data.
 * @param dataString The datastring from the downsampled url.
 * @param rangeStart The humidity value the encoded range starts with. Default is 2%.
 * @param resolution The unit resolution the encoded range is in. Default is 1.5%.
 * @returns An array with downsampled humidity values.
 */
export const parseHumidityDatapoints = (dataString, rangeStart = 2, resolution = 1.5) => {
    if (!dataString)
        return [];
    const charToValue = {};
    // Populate the mapping from character to value, shifting values to start from given rangeStart
    ENCODING_CHARACTERS.split('').forEach((char, index) => (charToValue[char] = index * resolution + rangeStart));
    return dataString.split('').map((char) => {
        if (char in charToValue) {
            return charToValue[char];
        }
        else {
            throw new Error(`Invalid character: ${char}`);
        }
    });
};
